export enum ThreadStatus {
  open = 'open',
  answered = 'answered',
  closed = 'closed',
}

export enum MessageType {
  text = 'text',
  close = 'close',
}

export abstract class SkyproCommunicationConfig {
  communicationApiDomain: string;
}
